import React from "react";

export function Error() {
    return <h1>Oops! Page not found !</h1>;
}